import { InjectionToken } from '@angular/core';

export type RulesDataModule = typeof import('./static-data/rules-data-v2');

export const RULES_DATA = new InjectionToken<RulesDataModule>('RULES_DATA');
